ion-list {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  display: block;
  contain: content;
  list-style-type: none;
}

ion-list.list-inset {
  transform: translateZ(0);
  overflow: hidden;
}

.list-ios {
  background: var(--ion-item-background, var(--ion-background-color, #fff));
}

.list-ios.list-inset {
  -webkit-margin-start: 16px;
  margin-inline-start: 16px;
  -webkit-margin-end: 16px;
  margin-inline-end: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 10px;
}

.list-ios.list-inset ion-item:last-child {
  --border-width: 0;
  --inner-border-width: 0;
}

.list-ios.list-inset + ion-list.list-inset {
  margin-top: 0;
}

.list-ios-lines-none .item-lines-default {
  --inner-border-width: 0px;
  --border-width: 0px;
}

.list-ios-lines-full .item-lines-default {
  --inner-border-width: 0px;
  --border-width: 0 0 0.55px 0;
}

.list-ios-lines-inset .item-lines-default {
  --inner-border-width: 0 0 0.55px 0;
  --border-width: 0px;
}

ion-card .list-ios {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
}